import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import App from './app';

import overall from './store/overall';
import storeOverall from '../denso-catalog/store/overall';

let entryPoint: HTMLElement;
let root: Root;

const initApp = (): void => {
  if (entryPoint.dataset.hasOwnProperty('isSearch')) {
    overall.setIsLinkSearch(true);
  }

  if (entryPoint.dataset.hasOwnProperty('isVin')) {
    storeOverall.setIsVINAvailable(true);
  }

  root = createRoot(entryPoint);
  root.render(React.createElement(App));
};

const init = (): void => {
  entryPoint = document.querySelector('.d-search-bar');

  if (entryPoint && entryPoint.dataset.hasOwnProperty('single')) {
    initApp();
  }
};

export default {
  init,
};
